<template>
  <div class="ui fullscreen modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="poll icon"></i>
      {{ $t("survey template") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/survey.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="ui two item top attached tabular menu" ref="tabsx">
            <a class="active item" data-tab="general">
              <i class="info icon"></i> {{ $t("general") }}</a
            >
            <a class="item" data-tab="questions">
              <i class="list icon"></i> {{ $t("content") }}</a
            >
          </div>
          <div class="ui bottom attached active tab segment" data-tab="general">
            <div class="fields">
              <div class="five wide field">
                <label for="">{{ $t("name") }}</label>
                <input type="text" name="name" v-model="name" />
              </div>
              <div class="three wide field">
                <label for="">{{ $t("expire time") }}</label>
                <div class="fields">
                  <div class="eight wide field">
                    <!-- <label for>{{
                            $t("reusable link time threshold")
                          }}</label> -->
                    <input
                      type="text"
                      name="time_threshold"
                      v-model="expire_time"
                    />
                  </div>
                  <div class="eight wide field">
                    <!-- <label for>{{ $t("reusable link time unit") }}</label> -->
                    <select
                      ref="expire_time_dropdown"
                      class="ui selection dropdown"
                      name="time_threshold_unit"
                      v-model="expire_time_unit"
                    >
                      <option value="">{{ $t("select one") }}</option>
                      <option value="day">{{ $t("day") }}</option>
                      <option value="week">{{ $t("week") }}</option>
                      <option value="month">{{ $t("month") }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="four wide field">
                <label for="">{{ $t("step buttons color") }}</label>
                <input
                  type="text"
                  name="step_button_color"
                  v-model="step_button_color"
                  :style="'background-color: #' + step_button_color"
                />
              </div>
              <div class="four wide field">
                <label for="">{{ $t("step marks color") }}</label>
                <input
                  type="text"
                  name="step_mark_color"
                  v-model="step_mark_color"
                  :style="'background-color: #' + step_mark_color"
                />
              </div>
            </div>
            <div class="fields">
              <div class="ten wide field">
                <label for="">{{ $t("logo") }}</label>
                <file-uploader
                  name="file"
                  url="/survey/template/do-upload-logo"
                  @error="error_uploading"
                  @uploaded="end_uploading"
                />
              </div>
              <img
                v-if="logo && logo.relative_path"
                class="ui small image"
                :src="api_host + '/' + logo.relative_path"
              />
            </div>
          </div>
          <div class="ui bottom attached tab segment" data-tab="questions">
            <questions :questions="questions" />
            <div class="ui error message"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, api_host } from "@/utils";
import Questions from "./Questions.vue";
import FileUploader from "@/components/FileUploader.vue";
// import Swatches from "vue-swatches";

export default {
  name: "SurveyTemplateModalIndex",
  components: { Questions, FileUploader },
  props: { module_configuration: Object },
  computed: {
    api_host() {
      return api_host;
    },
  },
  data() {
    return {
      name: "",
      logo: {},
      questions: [],
      expire_time: "",
      expire_time_unit: "",
      step_button_color: "",
      step_mark_color: "",
      form: undefined,
      uuid: "",
    };
  },
  methods: {
    error_uploading(err) {
      error_toast(err);
    },
    end_uploading(file) {
      let vm = this;
      vm.logo = file;
    },
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        console.log(data);
        if (data.uuid) vm.uuid = data.uuid;
        if (data.name) vm.name = data.name;
        if (data.setup.questions) vm.questions = data.setup.questions;
        if (data.setup.logo) vm.logo = data.setup.logo;
        if (data.setup.expire_time) vm.expire_time = data.setup.expire_time;
        if (data.setup.step_button_color)
          vm.step_button_color = data.setup.step_button_color;
        if (data.setup.step_mark_color)
          vm.step_mark_color = data.setup.step_mark_color;
        if (data.setup.expire_time_unit)
          window
            .jQuery(vm.$refs.expire_time_dropdown)
            .dropdown("set selected", data.setup.expire_time_unit);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            setTimeout(() => {
              window
                .jQuery(vm.$refs.tabsx)
                .find(".item")
                .tab();
            }, 300);

            window.jQuery(vm.$refs.expire_date_calendar).calendar({
              onSelect(value) {
                vm.expire_date = value;
              },
            });

            window.jQuery(vm.$refs.expire_time_dropdown).dropdown();
          },
          onHide() {
            vm.form.form("reset");
            vm.name = "";
            vm.logo = {};
            vm.questions = [];
            vm.expire_time = "";
            vm.expire_time_unit = "";
            vm.step_button_color = "fff";
            vm.step_mark_color = "fff";
            vm.form = undefined;
            vm.uuid = "";
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/survey/template/do-save", {
          n: vm.name,
          q: vm.questions,
          l: vm.logo,
          et: vm.expire_time,
          eu: vm.expire_time_unit,
          sbc: vm.step_button_color,
          smc: vm.step_mark_color,
          i: vm.uuid,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
